/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DIE NEUN ARTEN (Betreiber 13.09.2026, nach seiner Vorlage
 * „Banner Design System & Datenbank-Matrix").
 * 
 * „Ich verstehe die Einstellungen zum Baustein Banner ueberhaupt nicht
 * und finde es total kompliziert." Vorher standen vier Darstellungen,
 * sieben Anordnungen und sieben Feldrollen gleichzeitig auf der Maske —
 * auch die, die das gewaehlte Aussehen gar nicht zeigt. Jetzt waehlt man
 * ZUERST die Art; danach fragt die Maske nur noch die Felder, die diese
 * Art wirklich braucht.
 * 
 * SECHS MEHRZEILIGE (72 px) und DREI EINZEILIGE (34 px):
 * 
 *   DEAL_SPLIT      Badge · Ueberschrift · Text        | Button
 *   ICON_EXPRESS    Icon | Ueberschrift · Text         | Button
 *   GRUPPEN_STACK   Zielgruppe · Label / Ueberschrift  | Button
 *   GASTRO_FEATURE  Badge · Ueberschrift · Text        | Bild + Button
 *   PARTNER_CIRCLE  Bild (rund) | Ueberschrift · Text  | Button
 *   EVENT_CARD      Bild | Label · Ueberschrift · Text | Button
 *   QUICK_ACTION    Button | Ueberschrift              | Badge   (34 px)
 *   STATUS_BAR      Ueberschrift                       | Badge   (34 px)
 *   TICKER_LINE     Ueberschrift                       | Text    (34 px)
 * 
 * UND EINE ZEHNTE, DIE NICHTS VORGIBT (Betreiber 22.09.2026):
 * 
 *   FREIE_GESTALTUNG   ein einziges, im Editor gestaltetes Feld
 * 
 * Sein Beispiel: „Nehmen wir an wir haetten drei Anzeigen. 1 Vollflaechige
 * Grafik, 2 Eine dreizeilige mit rotem Hintergrund und weisser Schrift,
 * 3 Eine dreizeilige mit orangem Hintergrund und schwarzer Schrift. Wie
 * soll ich das darstellen?"
 * 
 * Gar nicht — bis hierher. Die ART kommt seit dem 22.09. je Datensatz,
 * die FARBEN aber sassen am Baustein und galten damit fuer alle
 * Eintraege gleich. Anzeige 2 und 3 waeren zwangsläufig gleich
 * ausgefallen.
 * 
 * Sein Vorschlag, und er ist besser als eigene Farbfelder: „wir haben
 * doch den tiptap editor. hier koennten wir die verschiedenen
 * Gestaltungsvarianten mit Farben direkt in der Subdatenbank anlegen und
 * braeuchten dann nur die Anzeige."
 * 
 * Genau das ist diese Art: Sie gibt KEINE Struktur vor und zeigt EIN
 * Feld ueber die ganze Flaeche — als formatierten Inhalt, samt der
 * Gestaltungsbausteine des Editors. Jede Anzeige bringt ihr Aussehen
 * selbst mit; der Baustein zeigt nur noch an.
 * 
 * DIE ALTEN SIEBEN SIND ERSETZT, NICHT UMGEZOGEN (ausdrueckliche
 * Entscheidung des Betreibers): Ein Baustein mit einem alten Wert
 * (`KIOSK_DEAL` & Co.) faellt auf `DEAL_SPLIT` zurueck und wird einmal
 * neu gewaehlt. Ein stiller Umzug haette geraten, welche neue Art
 * gemeint ist.
 * 
 * ══ DIE ALTEN SIEBEN BLEIBEN IM ENUM (13.09.2026, nach dem Ausfall) ══
 * 
 * Sie stehen NICHT mehr zur Wahl — die Maske bietet nur die neun an, und
 * die Anzeige zeichnet sie als `DEAL_SPLIT`. Loeschen darf man sie aber
 * NICHT: Jackson liest einen Enum-Wert streng. Ein Baustein, der noch
 * `SYMBOL_PILLE` trug, liess das Lesen der DATENBANK scheitern — und
 * damit die ganze Liste: „Fehler beim Laden der Datenbanken", 400,
 * `No enum constant … SYMBOL_PILLE`. Betroffen war jede Liste, in der
 * eine solche Datenbank vorkam.
 * 
 * „Ersetzen ohne Umzug" heisst also: aus der AUSWAHL nehmen, nicht aus
 * dem SCHEMA. Ein Wert, der einmal in Daten stand, muss lesbar bleiben,
 * solange diese Daten existieren.
 * @export
 */
export const DatabaseSubDbListLayout = {
    DealSplit: 'DEAL_SPLIT',
    IconExpress: 'ICON_EXPRESS',
    GruppenStack: 'GRUPPEN_STACK',
    GastroFeature: 'GASTRO_FEATURE',
    PartnerCircle: 'PARTNER_CIRCLE',
    EventCard: 'EVENT_CARD',
    QuickAction: 'QUICK_ACTION',
    StatusBar: 'STATUS_BAR',
    TickerLine: 'TICKER_LINE',
    FreieGestaltung: 'FREIE_GESTALTUNG',
    NurBild: 'NUR_BILD',
    KioskDeal: 'KIOSK_DEAL',
    SymbolPille: 'SYMBOL_PILLE',
    GruppenVorteil: 'GRUPPEN_VORTEIL',
    FotoRechts: 'FOTO_RECHTS',
    FotoRundLinks: 'FOTO_RUND_LINKS',
    EreignisDunkel: 'EREIGNIS_DUNKEL',
    FreieGrafik: 'FREIE_GRAFIK'
} as const;
export type DatabaseSubDbListLayout = typeof DatabaseSubDbListLayout[keyof typeof DatabaseSubDbListLayout];


export function DatabaseSubDbListLayoutFromJSON(json: any): DatabaseSubDbListLayout {
    return DatabaseSubDbListLayoutFromJSONTyped(json, false);
}

export function DatabaseSubDbListLayoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbListLayout {
    return json as DatabaseSubDbListLayout;
}

export function DatabaseSubDbListLayoutToJSON(value?: DatabaseSubDbListLayout | null): any {
    return value as any;
}

